<template>
  <b-container fluid>
    <AppLoader
      v-if="isLoadingForm"
      class="text-center"
      small
    />
    <div
      style="height:80vh;"
      class="m-0"
      v-else
    >
      <b-row v-if="form">
        <b-col cols="9">
          <div style="overflow: hidden;height: calc(100vh - 172px);">
            <b-row v-if="form">
              <b-col class="text-center">
                <h3 class="mt-2">{{form.formTitle ? form.formTitle[selectedLanguage || 'english'] : 'No Title'}}</h3>
                <p>{{form.formDescription ? form.formDescription[selectedLanguage || 'english'] : 'No Description'}}</p>
              </b-col>
            </b-row>

            <div
              id="scrollspy"
              class="preview-scrollable-wrapper p-3"
            >
              <div
                v-if="form.formSection.length"
                id="element"
                style="background-color:#F4F4F4;"
              >
                <b-form v-if="!isLoading">
                  <SectionContainer
                    v-for="(sectionData, index) in form.formSection"
                    :id="'section_'+index"
                    :isDisabled="isDisabled"
                    :isPreview="true"
                    :selectedLanguage="selectedLanguage"
                    :sectionData="sectionData"
                    :inputType="sectionData.inputType"
                    :key="index"
                    :counter="index"
                  />
                </b-form>
              </div>
            </div>
          </div>
          <b-row class="mt-3">
            <b-col
              cols="6"
              class="text-left"
            >
              <a
                v-if="form.formSection.length"
                href="#"
                class="btn btn-warning"
                v-scroll-to="{ el: '#scrollspy', container: '#scrollspy', duration: 300, easing: 'linear', force: true, x: false, y: true }"
              >
                <font-awesome-icon icon="angle-up" />
              </a>
            </b-col>
            <b-col>
              <!-- v-if="form.formSection.length && taskStatus !=4" -->

              <b-button-group class="float-right">
                <!-- @click="onSavePostData" -->
                <b-button
                  v-if="form.formSection.length && taskStatus !=4 && pageStatus != '2'"
                  variant="outline-primary"
                  :disabled="isLoading || isLoadingLocal"
                >
                  <span v-if="isLoading || isLoadingLocal">
                    <b-spinner
                      small
                      type="grow"
                    ></b-spinner>
                    {{$t('savingProgressText')}}
                  </span>
                  <span v-else>{{$t('saveProgressText')}}</span>
                </b-button>

                <!-- :isPreview="false" -->

                <!-- @click="onValidateSubmit" -->
                <b-button
                  v-if="form.formSection.length && taskStatus !=4 && pageStatus != '2'"
                  variant="outline-success"
                >{{$t('submitText')}}</b-button>
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>

        <!-- end of col-9 preview area righ sections list -->
        <b-col
          cols="3"
          class="mt-2"
          style="position:relative; overflow-y:auto; height:calc(100vh - 200px)"
        >
          <b-list-group v-b-scrollspy:scrollspy="50">
            <b-list-group-item
              :class="rightAlign ? 'text-right' : 'text-left'"
              v-for="(section,index) in form.formSection"
              :active="currentSectionIndex === index"
              @click="onScrollClick(index)"
              button
              :key="section.id"
            >
              <b-badge
                v-if="!rightAlign"
                variant="dark"
              >{{(index+1)}}</b-badge>
              &nbsp; {{ section.sectionTitle[selectedLanguage] }}
              <b-badge
                v-if="rightAlign && selectedLanguage == 'arabic'"
                variant="dark"
              >{{(new Intl.NumberFormat('ar-EG', { }).format(index+1))}}</b-badge>
              <b-badge
                v-if="rightAlign && selectedLanguage == 'hebrew'"
                variant="dark"
              >{{(index+1)}}</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>

    </div>
  </b-container>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import config from "../../configs/config";
import { Helper } from "../../helpers";
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import SectionContainer from "../../containers/SectionUserContainer";
import AppLoader from "../../components/Loader/Loader";
import { EventBus } from "@/event-bus.js";
import { HTTP } from "../../utils/HTTP";
import _ from "lodash";
import moment from "moment";
import "moment/locale/es";

export default {
  name: "EmployeeUserForm",
  components: {
    SectionContainer,
    AppLoader,
  },
  data () {
    return {

      isDisabled: 0,
      currentSectionIndex: 0,
      taskStatus: null,
      taskId: null,
      taskFiles: [],
      isLoadingLocal: false,
      isLoadingForm: false,
      form: null,
      pageStatus: null
    };
  },

  mounted () {
    // console.log( "userApoorval heere" )
    this.clearLocalStorage();
    this.pageStatus = this.$route.params.readOnly;
    // this.getTaskForm();
  },
  // props: {
  //   approval: Object
  // },

  computed: {
    ...mapGetters( {
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading",
    } ),

    ...mapState( {
      rightAlign: "rightAlign",
    } ),
  },

  watch: {

  },
  created () {
    EventBus.$on( "selctedValue", ( value ) => {
      this.form = null;
      this.getTaskForm( value );
    } );
  },
  methods: {
    onScrollClick ( index ) {
      let id = "section_" + index;
      this.currentSectionIndex = index;
      document.getElementById( id ).scrollIntoView( { behavior: "smooth" } );
    },

    clearLocalStorage () {
      localStorage.removeItem( "activeFormSchema" );
      localStorage.removeItem( "activeTaskStatus" );
      this.form = null;
    },
    async getTaskForm ( approval ) {
      this.isLoadingForm = true;
      // console.log( this.approval, "Approval" )
      try {
        let result = await HTTP(
          "post",
          "api/v1/approvals/type/schema",
          {
            approval_type_id: approval.value,
            approval: approval.text,
            employee_id: localStorage.getItem( "employeeId" )
          },
          null,
          true
        );
        console.log( result, "result" )
        this.isLoadingForm = false;

        if ( result.data.task ) {
          let form = JSON.parse( result.data.task.schema );
          // console.log( form, "newForss" )
          this.taskId = result.data.approval_id;
          this.form = form;
        }
      }
      catch ( error ) {
        this.isLoadingForm = false;
        console.log( error )
      }
    },
    // async onSavePostData () {
    //   EventBus.$emit( "onSubmitEndUserForm", "progress" );
    //   this.isLoadingLocal = true;
    //   let token = "Bearer " + localStorage.getItem( "accessToken" );
    //   let taskData = this.$store.state.userFormSubmitArray;
    //   try {
    //     await HTTP(
    //       "post",
    //       "api/v1/governance/training/employee/task/update",
    //       {
    //         task_status: 1,
    //         form_data: taskData,
    //         status: status,
    //         task_id: this.taskId,
    //         form_type: "governance",
    //         user_id: localStorage.getItem( "userId" ),
    //       },
    //       {
    //         Authorization: token,
    //       },
    //       null,
    //       false
    //     );
    //     this.isLoadingLocal = false;
    //     Helper.makeToast(
    //       this.$bvToast,
    //       "success",
    //       this.$t( "toast.saveSuccess" ),
    //       this.$t( "toast.title" )
    //     );
    //   } catch {
    //     this.isLoadingLocal = false;
    //     Helper.makeToast( this.$bvToast, "danger", this.$t( "toast.saveError" ) );
    //   }
    // },
    //  onValidateSubmit () {
    //   EventBus.$emit( "onSubmitEndUserForm", "form submit" );
    //   this.getInvalidFields();
    //   this.checkForInValidFields();
    // },
    //   getInvalidFields () {
    //   this.inValidElements = [];
    //   this.inValidSections = [];
    //   for ( let i = 0; i < this.$store.state.form1.formSection.length; i++ ) {
    //     for (
    //       let x = 0;
    //       x < this.$store.state.form1.formSection[i].formElements.length;
    //       x++
    //     ) {
    //       if (
    //         this.$store.state.form1.formSection[i].formElements[x].isInValid
    //       ) {
    //         this.inValidElements.push(
    //           this.$store.state.form1.formSection[i].formElements[x]
    //         );
    //       }
    //     }
    //   }
    // },

    // checkForInValidFields () {
    //   let isValid = false;
    //   outerLoop: for (
    //     let i = 0;
    //     i < this.$store.state.form1.formSection.length;
    //     i++
    //   ) {
    //     for (
    //       let x = 0;
    //       x < this.$store.state.form1.formSection[i].formElements.length;
    //       x++
    //     ) {
    //       if (
    //         this.$store.state.form1.formSection[i].formElements[x].isInValid
    //       ) {
    //         let inValidData = {
    //           elementId: this.$store.state.form1.formSection[i].formElements[x]
    //             .id,
    //           sectionId: this.$store.state.form1.formSection[i].id,
    //         };
    //         EventBus.$emit( "OnInvalidFieldCatch", inValidData );
    //         this.showErrorToast = true;
    //         isValid = false;
    //         break outerLoop;
    //       }
    //       isValid = true;
    //     }
    //   }
    //   if ( isValid ) {
    //     this.onReviewSubmit();
    //   }
    // }

  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
.preview-scrollable-wrapper {
  position: relative;
  overflow-y: auto;
  height: calc(100vh - 240px);
  /* height:400px */
}
.selectPicket {
  width: 350px;
}
</style>

